export default __webpack_public_path__ + "static/media/pusat-berbagi-pengetahuan-icon.d7cd0b9d.webp";